import { Injectable } from '@angular/core';
import { PaetepUserService } from '../paetep-user.service';
import { SessionService, User } from '@edl-development/edl-common';
import { firstValueFrom } from 'rxjs';
import { BaseUserDTO } from 'src/app/model/base/base-user-dto.model';

@Injectable({
    providedIn: 'root'
})
export class PaetepUserHelperService {

    constructor(
        private paetepUserService: PaetepUserService,
        private sessionService: SessionService
    ) { }

    getSelectEvaluatorOptions(
        targetUserId: string, 
        canCreateObservation: boolean,
        currentEvalUser?: {
            userId: string
            displayName: string
    }) {
        return firstValueFrom(
            this.paetepUserService.getSupervisors(targetUserId)
        ).then((supervisors: BaseUserDTO[]) => {
            const currentUser = this.sessionService.user;

            let evaluators = supervisors.map(s => { return { value: s.userID, label: s.displayName } });
    
            // Include current user if they do not show up in the evaluator list
            if (currentUser && canCreateObservation && evaluators.findIndex(e => e.value == currentUser?.UserID) === -1) {
                evaluators = [{ value: currentUser.UserID, label: currentUser.DisplayName }, ...evaluators]
            }
    
            // If current evaluator is not in the list then we need to add them
            if (currentEvalUser && evaluators.findIndex(e => e.value == currentEvalUser.userId) === -1) {
                evaluators = [{ value: currentEvalUser.userId, label: currentEvalUser.displayName }, ...evaluators]
            }

            // filter out target user
            evaluators = evaluators.filter(e => e.value !== targetUserId);
    
            evaluators = evaluators.sort((a, b) => a.label < b.label ? -1 : 1);

            return evaluators;
        })
    }
}
